var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.18 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072ce;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.53,9.81c-.36,0-.65.29-.65.65v4.88c0,1.17-.95,2.12-2.12,2.12H3.42c-1.17,0-2.12-.95-2.12-2.12v-4.88c0-.36-.29-.65-.65-.65s-.65.29-.65.65v4.88c0,1.88,1.53,3.42,3.42,3.42h11.35c1.88,0,3.42-1.53,3.42-3.42v-4.88c0-.36-.29-.65-.65-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.99,6.83c.17,0,.34-.07.47-.2l3.93-4.12v11.63c0,.36.29.65.65.65s.65-.29.65-.65V2.54l3.95,3.95c.25.25.67.25.92,0,.25-.25.25-.67,0-.92L9,0,3.52,5.73c-.25.26-.24.67.02.92.13.12.29.18.45.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.12594802498daea44d1d09d0efb5ddbe.svg";
export { ForwardRef as ReactComponent };